import { createSelector } from "@ngrx/store";
import { IExameState } from "./exame.reducer";

const exameStore = (state: any) => state.exame as IExameState;

export const selectExameLista = createSelector(
    exameStore,
    (state) => state.lista
);

export const selectExamByID = createSelector(
    exameStore,
    (state) => state.examByID
);

export const selectExamLoading = createSelector(
    exameStore,
    (state) => state.isLoading
)

export const selectExamState = createSelector(
    exameStore,
    (state) => ({type: state.type, action: state.action})
)

export const selectExamTotalItems = createSelector(
    exameStore,
    (state) => ({total: state.totalItems})
)